<section id="projects" >
    <div class="container">
      <div class="title">
        <h1>Web Work</h1>
      </div>
      <div class="row">

        <div class="col-md-3" *ngFor="let item of ProjectList" data-aos="fade-right">
          <div class="card text-center">
  <img src={{item.cardThumb}} height="210px"  alt="radiobox" class="card-img-top">
  <div class="card-body">
    <h5 class="card-title">
        {{item.cardTitle}}
    </h5>
    <p class="card-text">{{item.cardDescription}}</p>
    <a href={{item.demoLink}} class="press" target="_blank">Demo</a>
  </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="projects">
    <div class="container">
      <div class="title1">
        <h1>Design work</h1>
      </div>
      <div class="row" data-aos="fade-left">
        <div class="col-md-3" *ngFor="let x of DesignList">
          <div class="card text-center">
  <img src={{x.cardThumb}}  height="250px" alt="radiobox" class="card-img-top">
  <div class="card-body">
    <h5 class="card-title">
        {{x.cardTitle}}
    </h5>
    <p class="card-text">{{x.cardDescription}}</p>
    <a href={{x.demoLink}} target="_blank">Demo</a>
  </div>
          </div>
        </div>
        
      </div>
      <button class="btn btn-primary" ><a href="https://www.behance.net/ph4ntomassassin/projects" target="_blank">More</a></button>
    </div>
  </section>